import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, Renderer2 } from '@angular/core';
import { deepCopy, DwComponent, DwComponentType, DwExpressionService, DwImageResizeOptions, DwImageSizeOptions, DwMediaEntity, DwMediaRepositoryService, DwMetaDataFormApi, DwMetaDataFormSectionStateService, DwMetaDataFormStateService, DwMetaDataService, DwMetaDataServiceToken, DwRoMediaEntity, DwSectionBaseComponent, DwSectionReadonlyBaseComponent, DwThemeManagerService, DwThemeRespositoryService, DwUiConfigRegistryService, DwUIMetaDataConfig, DwUIMetaDataConfigToken } from '@devwareapps/devware-cap';
import { AppMetaData, AppMetaDataItemNames, AppMetaDataLookups, CourseLessonEntity, DwThemeEntity, DwThemePropertyDefinitionEntity, FlightSchoolBrandingEntity, FlightSchoolEntity, LessonTypeAllItems, StandardColorSetEntity, StandardLoginMediaWithMediaPathQueryEntity, SubscriptionFeatureKeys, VideoEntity } from '../../../../meta-data/app-meta-data.service';
import { LessonNavigationInfo } from '../../../courses/models/lesson-navigation-info.model';
import { LessonProgressHierarchy } from '../../../courses/models/lesson-progress-hierarchy.model';
import { CourseNavigationService } from '../../../courses/services/course-navigation.service';
import { LessonFlagUtilService } from '../../../courses/services/lesson-flag-util.service';
import { DateTimeUtilService } from '../../../shared/util/date-time-util.service';
import { DwThemeProperties } from '../../models/theme-properties.enum';
import { SchoolRepositoryService } from '../../services/school-repository.service';
import { FormControl, ValidatorFn } from '@angular/forms';
import { CourseRepositoryService } from '../../../courses/services/course-repository.service';
import { IntegrationUtilService } from '../../../integration/services/integration-util.service';
import { BrandingPreviewPayload } from '../../../integration/models/branding-preview-payload.model';
import { combineLatest, of } from 'rxjs';
import { LoginSideImagePickerOption } from '../login-side-image-picker/login-side-image-picker.component';
import { delay, take } from 'rxjs/operators';



@DwComponent({
   key: 'SchoolBrandingSetup',
   name: 'School Branding Setup',
   componentType: DwComponentType.formSection,
   parentItemName: AppMetaDataItemNames.FlightSchoolBranding,

})
@Component({
  selector: 'app-school-branding-setup',
  templateUrl: './school-branding-setup.component.html',
  styleUrls: ['./school-branding-setup.component.scss']
})
export class SchoolBrandingSetupComponent extends DwSectionReadonlyBaseComponent {
  flightSchool: FlightSchoolEntity;
  theme: DwThemeEntity;
  formApi: DwMetaDataFormApi; 
  autoApplyTheme = true;
  colorSetLookupId = AppMetaDataLookups.StandardColorSetAllItems;

  showAdjustLogo = false;
  readonly logoAllowedFileTypes = '.jpg,.jpeg,.gif,.png,.bmp,.webp,.svg';
 
  readonly DwThemeProperties = DwThemeProperties;
  
  logoMediaImageReSize: DwImageResizeOptions = {
    cropWidth: 200,
    cropHeight: 200,
    cropRound: false,
    outputWidth: 400,
    outputHeight: 400,
    maintainAspectRatio: true,
    allowResize: true
  };

  authSideImageResizeOptions: DwImageResizeOptions = null;
  // {
  //   cropWidth: 900,
  //   cropHeight: 1200,
  //   cropRound: false,
  //   outputWidth: 900,
  //   outputHeight: 1200,
  //   allowResize: true
  // };

  logoSizeOptions: DwImageSizeOptions = {
     cropToCircle: true,
     height: 150,
     width: 150,
  }
  colorSets: StandardColorSetEntity[];
  isReadOnly: boolean;
  themeControl: FormControl;
  navigationColorSetId: FormControl;
  sidebarColorSetId: FormControl; 
  hasWhiteLabelingFeature: boolean = false;
  hasMobileWhiteLabelingFeature = false;
  readonly mobileIconMetadataReady = 'MobileAppIconMediaId' in AppMetaData.FlightSchoolBranding.Attributes;
  mobileIconMedia: DwRoMediaEntity;
  mobileIconPreviewUrl = '';
  mobileIconError = '';
  readonly mobileIconResizeOptions: DwImageResizeOptions = {
    cropWidth: 250, cropHeight: 250, cropRound: false,
    outputWidth: 1024, outputHeight: 1024, maintainAspectRatio: true, allowResize: true
  };

  setMobileIconMedia(media: DwRoMediaEntity | DwMediaEntity): void {
    if (this.isReadOnly || !this.hasMobileWhiteLabelingFeature || !this.mobileIconMetadataReady
        || !this.flightSchool?.FlightSchoolBranding) {
      return;
    }
    const normalized = this.normalizeRoMedia(media);
    if (normalized && (normalized.ImageWidth !== 1024 || normalized.ImageHeight !== 1024)) {
      this.mobileIconError = 'Choose a PNG image resized to 1024 × 1024 pixels.';
      return;
    }
    this.mobileIconError = '';
    const branding: FlightSchoolBrandingEntity = this.flightSchool.FlightSchoolBranding;
    branding.MobileAppIconMediaId = normalized?.MediaId || null;
    this.mobileIconMedia = normalized;
    this.mobileIconPreviewUrl = normalized?.MediaPath
      ? this.dwMediaRepositoryService.getImageUrlFromMediaPath(normalized.MediaPath) : '';
  }

  setSideLogoMedia(media: DwRoMediaEntity | DwMediaEntity) {
    const normalizedMedia = this.normalizeRoMedia(media);

    this.sideLogoMedia = normalizedMedia;

    this.theme.AlternateLogoMediaId = normalizedMedia?.MediaId;
    this.theme.LogoLoginMediaId = normalizedMedia?.MediaId;
    this.showAdjustLogo = false;

    const logoSize = this.getContainImageSize(normalizedMedia, 200, 125);
    this.theme.AlternateLogoWidth = logoSize.width;
    this.theme.AlternateLogoHeight = logoSize.height;

    this.setupLogo();
    this.applyTheme();
  }

  setAuthSideImageMedia(media: DwRoMediaEntity | DwMediaEntity) {
    this.selectCustomLoginMedia(media);
  }

  selectCustomLoginMedia(media: DwRoMediaEntity | DwMediaEntity) {
    const normalizedMedia = this.normalizeRoMedia(media);

    if (!normalizedMedia) {
      return;
    }

    this.authSideImageMedia = normalizedMedia;
    this.flightSchool.FlightSchoolBranding.UseCustomLoginMedia = true;
    this.flightSchool.FlightSchoolBranding.StandardLoginMediaId = null;
    this.theme.LogoMediaId = normalizedMedia?.MediaId;

    this.theme.LogoWidth = 0;
    this.theme.LogoHeight = 0;
    this.upsertCustomLoginMediaOption(normalizedMedia);

    this.syncCurrentLoginSideImageOption();
    this.setupAuthSideImage();
    this.applyTheme();
  }

  selectStandardLoginMedia(option: LoginSideImagePickerOption) {
    if (!option) {
      return;
    }

    this.flightSchool.FlightSchoolBranding.UseCustomLoginMedia = !!option.isCustom;
    this.flightSchool.FlightSchoolBranding.StandardLoginMediaId = option.isCustom ? null : option.standardLoginMediaId;
    this.theme.LogoMediaId = option.mediaId;
    this.theme.LogoWidth = 0;
    this.theme.LogoHeight = 0;
    this.authSideImageMedia = this.createMediaFromOption(option);

    this.syncCurrentLoginSideImageOption();
    this.setupAuthSideImage();
    this.applyTheme();
  }

  setCustomLoginMediaGroupId(mediaGroupId: number): void {
    if (!mediaGroupId || this.flightSchool?.FlightSchoolBranding?.CustomLoginMediaGroupId === mediaGroupId) {
      return;
    }

    this.flightSchool.FlightSchoolBranding.CustomLoginMediaGroupId = mediaGroupId;
    this.loadCustomLoginMediaOptions(mediaGroupId);
  }


  stylePropertyConfig = [{
      propertyDef: DwThemeProperties.topNavigationBackgroundColor,
    },
    {
      propertyDef: DwThemeProperties.topNavigationTextColor,
    },
    // {
    //   propertyDef: DwThemeProperties.topNavigationBarHeight,
    // },
    {
      propertyDef: DwThemeProperties.sidebarBackgroundColor,
    },
    {
      propertyDef: DwThemeProperties.sidebarTextColor,
    },
]
  themeProperyDefs: DwThemePropertyDefinitionEntity[];
  sideLogoMedia: DwRoMediaEntity;
  authSideImageMedia: DwRoMediaEntity;
  customLoginMediaOptions: LoginSideImagePickerOption[] = [];
  currentLoginSideImageOption: LoginSideImagePickerOption;
  standardLoginMediaOptions: LoginSideImagePickerOption[] = [];
  
  constructor(
    dwExpressionService: DwExpressionService,
    protected dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    dwFormStateService: DwMetaDataFormStateService,
    private courseRepositoryService: CourseRepositoryService,
    private courseNavigationService: CourseNavigationService,
    private dateTimeUtilService: DateTimeUtilService,
    private lessonFlagUtilService: LessonFlagUtilService,
    private dwThemeRepositoryService: DwThemeRespositoryService,
    private dwThemeManagerService: DwThemeManagerService,
    private schoolRepositoryService: SchoolRepositoryService,
    dwFormSectionStateService: DwMetaDataFormSectionStateService,
    private dwMediaRepositoryService: DwMediaRepositoryService,
    private integrationUtilService: IntegrationUtilService,
    private changeDetectorRef: ChangeDetectorRef,
    private elementRef: ElementRef<HTMLElement>,
    private renderer: Renderer2,
     
  ) {
    super(dwExpressionService, dwFormSectionStateService, dwFormStateService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
    this.formApi = this.dwFormStateService.state.formApi;

    this.dwThemeRepositoryService.getThemePropertyDefinitions().subscribe((themeProperyDefs) => {
      this.themeProperyDefs = themeProperyDefs;
    });
  } 
  
  ngOnInit(): void {
    this.markViewEditContainer();
    this.setupFormControls();

    this.sectionReadOnlyChanged(this.isSectionReadOnly());

    this.runAfterFormDataLoaded(() => {
      this.setupForm();
    });

    this.schoolRepositoryService.hasAnyFeatureWithLoad(SubscriptionFeatureKeys.WhiteLabelingFullDomain, SubscriptionFeatureKeys.WhilteLabeling)
      .subscribe(hasWhiteLabelingFeature => {
        this.hasWhiteLabelingFeature = hasWhiteLabelingFeature;
      });

    // Features is the subscription entitlement collection; SchoolFeatures is
    // a separate capability collection and must not grant mobile white labeling.
    this.subscriptions.push(this.schoolRepositoryService.hasAnyFeatureWithLoad(SubscriptionFeatureKeys.MobileWhiteLabeling)
      .subscribe(enabled => {
        this.hasMobileWhiteLabelingFeature = enabled;
        this.changeDetectorRef.markForCheck();
      }));

    this.schoolRepositoryService.getColorSets()
      .subscribe(colorSets => {
        this.colorSets = colorSets;

        this.updateColorSet();
      });
  }

  
  setupFormControls() {
    return;
    // Form group represents FlightSchoolBranding table

    const originalValue = this.formApi.getFormData<FlightSchoolEntity>();

    //this.themeControl = this.addControl('DwTheme');
    this.navigationColorSetId = this.addControl('NavigationColorSetId');
    this.sidebarColorSetId = this.addControl('SidebarColorSetId');

   // this.formGroup.patchValue(this.flightSchool.FlightSchoolBranding);
  }

  
  sectionReadOnlyChanged(readOnly: boolean): void {
    this.isReadOnly = readOnly;

    return;
     if (this.isReadOnly) {
      this.navigationColorSetId.disable();
      this.sidebarColorSetId.disable();
    } else {
      this.navigationColorSetId.enable();
      this.sidebarColorSetId.enable();
    }
  }

  updateColorSet() {
    if (!this.flightSchool?.FlightSchoolBranding) {
      return;
    }

    this.flightSchool.FlightSchoolBranding.LoginColorSetId = this.flightSchool.FlightSchoolBranding.NavigationColorSetId;

    this.setThemeColorSet(this.flightSchool.FlightSchoolBranding.NavigationColorSetId, DwThemeProperties.topNavigationBackgroundColor, DwThemeProperties.topNavigationTextColor);
    this.setThemeColorSet(this.flightSchool.FlightSchoolBranding.SidebarColorSetId, DwThemeProperties.sidebarBackgroundColor, DwThemeProperties.sidebarTextColor);
    this.setThemeColorSet(this.flightSchool.FlightSchoolBranding.NavigationColorSetId, DwThemeProperties.loginButtonBackground, DwThemeProperties.loginButtonTextColor);
    this.updateReadOnlyColorSummary();
  }

  private markViewEditContainer(): void {
    const viewEditContainer = this.elementRef.nativeElement.closest('dw-view-edit-section');

    if (viewEditContainer) {
      this.renderer.addClass(viewEditContainer, 'aviator-school-branding-view-edit');
    }
  }

  private updateReadOnlyColorSummary(): void {
    const branding = this.flightSchool?.FlightSchoolBranding;
    const navigationColorSet = this.colorSets?.find(colorSet => colorSet.StandardColorSetId === branding?.NavigationColorSetId);
    const sidebarColorSet = this.colorSets?.find(colorSet => colorSet.StandardColorSetId === branding?.SidebarColorSetId);

    this.readonlyNavigationLabel = navigationColorSet?.ColorSetName || 'Not set';
    this.readonlySidebarLabel = sidebarColorSet?.ColorSetName || 'Not set';
    this.readonlyNavigationStyle = {
      'background-color': navigationColorSet?.BackgroundColor || '#f4f5f7'
    };
    this.readonlySidebarStyle = {
      'background-color': '#fff'
    };
    this.readonlySidebarRailStyle = {
      'background-color': sidebarColorSet?.BackgroundColor || '#f4f5f7'
    };
  }

  autoApplyThemeChange() {
    if (this.autoApplyTheme) {
      this.applyTheme();
    }
  }

  themeChange() {
    this.autoApplyThemeChange();
  }

  applyTheme() {
    if (!this.hasWhiteLabelingFeature) {
      return;
    }

    const theme = deepCopy(this.theme);

    theme.DwThemeProperty = theme.DwThemeProperty.filter(p => p.PropertyValue);

    this.setupLogo();

    this.dwThemeManagerService.applyThemeRaw(theme).subscribe(() => {});

    this.themeProperyDefs = [...this.themeProperyDefs || []]
  }

  
  undoTheme() {
    //this.dwThemeManagerService.applyTheme().subscribe(() => {});
  }
 
  private setupForm() {
    this.flightSchool = this.formApi.getFormData();

    this.theme = this.flightSchool?.FlightSchoolBranding?.DwTheme;
    const branding: FlightSchoolBrandingEntity = this.flightSchool?.FlightSchoolBranding;
    const mediaIds = [this.theme?.AlternateLogoMediaId, this.theme?.LogoLoginMediaId, this.theme?.LogoMediaId,
      this.mobileIconMetadataReady ? branding?.MobileAppIconMediaId : null]
      .filter(mediaId => !!mediaId);

    const mediaLoad$ = mediaIds.length
      ? this.dwThemeManagerService.getMediaCached(mediaIds)
      : of([]);

    const standardLoginMediaLoad$ = this.schoolRepositoryService.getStandardLoginMediaOptions();
    const customLoginMediaLoad$ = this.schoolRepositoryService.getCustomLoginMediaOptions(this.flightSchool?.FlightSchoolBranding?.CustomLoginMediaGroupId);

    combineLatest([mediaLoad$, standardLoginMediaLoad$, customLoginMediaLoad$])
      .pipe(take(1), delay(20))
      .subscribe(([media, standardLoginMedia, customLoginMedia]) => {
        this.sideLogoMedia = media?.find(m => m?.MediaId === this.theme?.AlternateLogoMediaId)
          || media?.find(m => m?.MediaId === this.theme?.LogoLoginMediaId);
        this.authSideImageMedia = media?.find(m => m?.MediaId === this.theme?.LogoMediaId);
        this.mobileIconMedia = media?.find(m => m?.MediaId === branding?.MobileAppIconMediaId);
        this.mobileIconPreviewUrl = this.mobileIconMedia?.MediaPath
          ? this.dwMediaRepositoryService.getImageUrlFromMediaPath(this.mobileIconMedia.MediaPath) : '';
        this.mobileIconError = '';
        this.standardLoginMediaOptions = this.mapStandardLoginMediaOptions(standardLoginMedia || []);
        this.customLoginMediaOptions = this.mapCustomLoginMediaOptions(customLoginMedia || []);
        this.syncCurrentLoginSideImageOption();
        this.setupLogo();
        this.setupAuthSideImage();
        this.changeDetectorRef.detectChanges();
      });
  }

  setThemeColorSet(colorSetId: number, backgroundColorPropertyId: number, foregroundPropertyId: number) {
    const colorSet = this.colorSets.find(c => c.StandardColorSetId === colorSetId);

    this.setThemeProperty(backgroundColorPropertyId, colorSet?.BackgroundColor);
    this.setThemeProperty(foregroundPropertyId, colorSet?.ForegroundColor);
  }

  sideLogoStyle: any = {};
  authSideImageStyle: any = {};
  readonlyLogoStyle: any = {};
  readonlyLoginImageStyle: any = {};
  readonlyNavigationStyle: any = {};
  readonlySidebarStyle: any = {};
  readonlySidebarRailStyle: any = {};
  readonlyNavigationLabel = '';
  readonlySidebarLabel = '';

  setImageSizeHeight() {
    this.setupLogo();
    this.applyTheme();
  }

  setImageSize() {
    // Make these the same
   // this.theme.AlternateLogoHeight = this.theme.AlternateLogoWidth;
    this.setupLogo();
    this.applyTheme();
  }

  setupLogo() {
    const imageUrl = this.dwMediaRepositoryService.getImageUrlFromMediaPath(this.sideLogoMedia?.MediaPath);

    this.sideLogoStyle = {
      'width': `${this.theme.AlternateLogoWidth}px`,
      'height': `${this.theme.AlternateLogoHeight}px`,
      'background-image': `url(${imageUrl})`,
      'background-repeat': 'no-repeat',
      'background-size': 'contain',
      'border': '1px dashed black',
    }

    this.readonlyLogoStyle = {
      'width': `${this.theme?.AlternateLogoWidth || 125}px`,
      'height': `${this.theme?.AlternateLogoHeight || 125}px`,
      'background-image': imageUrl ? `url(${imageUrl})` : 'none'
    };
  }

  setupAuthSideImage() {
    const imageUrl = this.dwMediaRepositoryService.getImageUrlFromMediaPath(this.authSideImageMedia?.MediaPath);

    this.authSideImageStyle = {
      'background-image': imageUrl ? `url(${imageUrl})` : 'none',
      'background-position': 'center',
      'background-repeat': 'no-repeat',
      'background-size': 'cover',
      'border': '1px dashed black',
      'border-radius': '12px',
    };

    this.readonlyLoginImageStyle = {
      'background-image': imageUrl ? `url(${imageUrl})` : 'none'
    };
  }

  previewLogin(): void {
    const payload = this.buildBrandingPreviewPayload();
    const previewUrl = this.integrationUtilService.getBrandingPreviewLoginUrl();

    this.integrationUtilService.saveBrandingPreviewPayload(payload);
    window.open(previewUrl, '_blank');
  }

  private getContainImageSize(media: DwRoMediaEntity, maxSize: number, defaultSize: number): { width: number, height: number } {
    if (media?.ImageWidth && media?.ImageHeight) {
      if (media.ImageWidth > media.ImageHeight) {
        const ratio = media.ImageHeight / media.ImageWidth;
        const width = media.ImageWidth > maxSize ? maxSize : media.ImageWidth;

        return {
          width: Math.ceil(width),
          height: Math.ceil(width * ratio)
        };
      }

      const ratio = media.ImageWidth / media.ImageHeight;
      const height = media.ImageHeight > maxSize ? maxSize : media.ImageHeight;

      return {
        width: Math.ceil(height * ratio),
        height: Math.ceil(height)
      };
    }

    return {
      width: defaultSize,
      height: defaultSize
    };
  }

  private buildBrandingPreviewPayload(): BrandingPreviewPayload {
    return {
      schoolDisplayName: this.flightSchool?.FlightSchoolName,
      topNavigationBackgroundColor: this.getThemePropertyValue(DwThemeProperties.topNavigationBackgroundColor),
      topNavigationTextColor: this.getThemePropertyValue(DwThemeProperties.topNavigationTextColor),
      sidebarBackgroundColor: this.getThemePropertyValue(DwThemeProperties.sidebarBackgroundColor),
      sidebarTextColor: this.getThemePropertyValue(DwThemeProperties.sidebarTextColor),
      loginLogoUrl: this.dwMediaRepositoryService.getImageUrlFromMediaPath(this.sideLogoMedia?.MediaPath),
      loginLogoWidth: this.theme?.AlternateLogoWidth,
      loginLogoHeight: this.theme?.AlternateLogoHeight,
      authSideImageUrl: this.dwMediaRepositoryService.getImageUrlFromMediaPath(this.authSideImageMedia?.MediaPath),
    };
  }

  private getThemePropertyValue(propertyId: DwThemeProperties): string {
    return this.theme?.DwThemeProperty?.find(p => p.ThemePropertyDefinitionId === propertyId && !p._isDeleted)?.PropertyValue || '';
  }

  private syncCurrentLoginSideImageOption(): void {
    const branding = this.flightSchool?.FlightSchoolBranding;

    if (branding?.UseCustomLoginMedia && this.authSideImageMedia?.MediaPath) {
      const savedCustomOption = this.customLoginMediaOptions.find(option => option.mediaId === this.authSideImageMedia.MediaId);

      this.currentLoginSideImageOption = {
        ...(savedCustomOption || {}),
        imageHeight: this.authSideImageMedia.ImageHeight,
        imageWidth: this.authSideImageMedia.ImageWidth,
        isCurrent: true,
        isCustom: true,
        label: savedCustomOption?.label || this.authSideImageMedia.MediaName || 'Custom Upload',
        mediaId: this.authSideImageMedia.MediaId,
        mediaPath: this.authSideImageMedia.MediaPath,
        previewUrl: this.dwMediaRepositoryService.getImageUrlFromMediaPath(this.authSideImageMedia.MediaPath)
      };

      return;
    }

    const selectedStandardOption = this.standardLoginMediaOptions
      .find(option => option.standardLoginMediaId === branding?.StandardLoginMediaId);
    const matchedThemeOption = this.standardLoginMediaOptions
      .find(option => option.mediaId === this.theme?.LogoMediaId);
    const defaultOption = this.standardLoginMediaOptions.find(option => option.isDefault) || this.standardLoginMediaOptions[0];
    const fallbackMediaOption = this.authSideImageMedia?.MediaPath
      ? {
          imageHeight: this.authSideImageMedia.ImageHeight,
          imageWidth: this.authSideImageMedia.ImageWidth,
          isCustom: !!branding?.UseCustomLoginMedia,
          label: this.authSideImageMedia.MediaName || 'Login Side Image',
          mediaId: this.authSideImageMedia.MediaId,
          mediaPath: this.authSideImageMedia.MediaPath,
          previewUrl: this.dwMediaRepositoryService.getImageUrlFromMediaPath(this.authSideImageMedia.MediaPath)
        } as LoginSideImagePickerOption
      : null;
    const currentOption = selectedStandardOption || matchedThemeOption || fallbackMediaOption || defaultOption;

    this.currentLoginSideImageOption = currentOption
      ? { ...currentOption, isCurrent: true, isCustom: currentOption.isCustom || false }
      : null;

    if (currentOption?.mediaPath) {
      this.authSideImageMedia = this.createMediaFromOption(currentOption);
    }
  }

  private mapStandardLoginMediaOptions(standardLoginMedia: StandardLoginMediaWithMediaPathQueryEntity[]): LoginSideImagePickerOption[] {
    return [...(standardLoginMedia || [])]
      .sort((left, right) => {
        if ((left.IsDefault ? 1 : 0) !== (right.IsDefault ? 1 : 0)) {
          return (right.IsDefault ? 1 : 0) - (left.IsDefault ? 1 : 0);
        }

        return (left.LoginMediaName || left.DwroMediaMediaName || '')
          .localeCompare(right.LoginMediaName || right.DwroMediaMediaName || '');
      })
      .map(item => ({
        imageHeight: item.DwroMediaImageHeight,
        imageWidth: item.DwroMediaImageWidth,
        isDefault: item.IsDefault,
        label: item.LoginMediaName || item.DwroMediaMediaName || 'Standard Image',
        mediaId: item.MediaId,
        mediaPath: item.DwroMediaMediaPath,
        previewUrl: this.dwMediaRepositoryService.getImageUrlFromMediaPath(item.DwroMediaMediaPath),
        standardLoginMediaId: item.StandardLoginMediaId
      }));
  }

  private mapCustomLoginMediaOptions(customLoginMedia: DwRoMediaEntity[]): LoginSideImagePickerOption[] {
    return [...(customLoginMedia || [])]
      .sort((left, right) => (right.CreatedDateTime || '').localeCompare(left.CreatedDateTime || ''))
      .map(item => ({
        imageHeight: item.ImageHeight,
        imageWidth: item.ImageWidth,
        isCustom: true,
        label: 'Custom',
        mediaId: item.MediaId,
        mediaPath: item.MediaPath,
        previewUrl: this.dwMediaRepositoryService.getImageUrlFromMediaPath(item.MediaPath)
      }));
  }

  private createMediaFromOption(option: LoginSideImagePickerOption): DwRoMediaEntity {
    return {
      MediaId: option?.mediaId,
      MediaName: option?.label,
      MediaPath: option?.mediaPath,
      ImageWidth: option?.imageWidth,
      ImageHeight: option?.imageHeight
    } as DwRoMediaEntity;
  }

  private normalizeRoMedia(media: DwRoMediaEntity | DwMediaEntity): DwRoMediaEntity {
    if (!media) {
      return null;
    }

    const roMedia = (media as DwMediaEntity).DwroMedia || media as DwRoMediaEntity;

    return {
      ...(roMedia || {}),
      ImageHeight: roMedia?.ImageHeight,
      ImageWidth: roMedia?.ImageWidth,
      MediaGroupId: roMedia?.MediaGroupId || media?.MediaGroupId,
      MediaId: roMedia?.MediaId || media?.MediaId,
      MediaName: roMedia?.MediaName || media?.MediaName,
      MediaPath: roMedia?.MediaPath
    } as DwRoMediaEntity;
  }

  private loadCustomLoginMediaOptions(mediaGroupId: number): void {
    this.schoolRepositoryService.getCustomLoginMediaOptions(mediaGroupId)
      .subscribe(customLoginMedia => {
        this.customLoginMediaOptions = this.mapCustomLoginMediaOptions(customLoginMedia || []);
        this.syncCurrentLoginSideImageOption();
        this.changeDetectorRef.detectChanges();
      });
  }

  private upsertCustomLoginMediaOption(media: DwRoMediaEntity): void {
    const option: LoginSideImagePickerOption = {
      imageHeight: media?.ImageHeight,
      imageWidth: media?.ImageWidth,
      isCustom: true,
      label: 'Custom',
      mediaId: media?.MediaId,
      mediaPath: media?.MediaPath,
      previewUrl: this.dwMediaRepositoryService.getImageUrlFromMediaPath(media?.MediaPath)
    };

    this.customLoginMediaOptions = [
      option,
      ...(this.customLoginMediaOptions || []).filter(existingOption => existingOption.mediaId !== option.mediaId)
    ];
  }


  setThemeProperty(propertyId: number, value: string) {
    let property = this.theme.DwThemeProperty.find(p => p.ThemePropertyDefinitionId === propertyId);

    if (!property) {
      property = AppMetaData.DwThemeProperty.CreateEntity();
      property.ThemePropertyDefinitionId = propertyId;

      this.theme.DwThemeProperty.push(property);
    }

    property.PropertyValue = value;

    if (!value) {
      property._isDeleted = true;
    } else {
      property._isDeleted = false;
    }

    this.autoApplyThemeChange();
  }


  
  protected addControl(controlName: string, validatorVn: ValidatorFn = null, initialValue?: any): FormControl {
    let control = this.formGroup.get(controlName) as FormControl;

    if (!control) {
      control = new FormControl();

      this.formGroup.addControl(controlName, control);
    }

    if (initialValue) {
        control.setValue(initialValue);
    }

    control.validator = validatorVn;

    control.enable();

    return control;
  }

}
